import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { hasFullConsent, initAnalytics, initAnonymousAnalytics } from "@/lib/analytics";

// Initialize PostHog BEFORE React mounts.
// This ensures PostHog is ready when component useEffects fire
// (React runs child effects before parent effects, so QuizIntro's
// trackQuizIntroViewed would fire before App's init useEffect).
if (hasFullConsent()) {
  initAnalytics();
} else {
  initAnonymousAnalytics();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
